"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 2/16/2017.
 */
var PeriodUtil = /** @class */ (function () {
    function PeriodUtil() {
    }
    /**
     * Method throw Error if range is invalid
     * @param startDate
     * @param endDate
     */
    PeriodUtil.check = function (startDate, endDate) {
        if (!startDate || !endDate)
            throw Error("Invalid Range");
        if (endDate < startDate)
            throw Error("Invalid Range");
    };
    /**
     * Method return thie next id of quarterId:
     * For e.g. for 20154 method return 20161
     *
     * @param quarterId
     * @returns {number} next querterId
     */
    PeriodUtil.quarterAdd = function (quarterId) {
        var quarter = quarterId % 10;
        var year = Math.floor(quarterId / 10);
        if (4 < quarter || quarter < 0) {
            throw new Error("Invalid quarterId " + quarterId);
        }
        if (quarter == 4)
            return (year + 1) * 10 + 1;
        return quarterId + 1;
    };
    /**
     * Method return thie next id of querterId:
     * For e.g. for 2015103 method return 2016204
     *
     * @param monthId
     * @returns {number} next monthId
     */
    PeriodUtil.monthAdd = function (monthId) {
        var month = monthId % 100;
        var year = Math.floor(monthId / 1000);
        if (12 < month || month < 1) {
            throw new Error("Invalid quarterId " + monthId);
        }
        if (month == 12) {
            month = 1;
            year++;
        }
        else {
            month++;
        }
        return (year * 10 + PeriodUtil.getQuarterIdByMonth(month - 1)) * 100 + month;
    };
    /**
     * Method return quarterId by Date:
     * For e.g for 2016/7/1 date method return 20163
     *
     * @param date
     * @param shiftMonth
     * @returns {number}
     */
    PeriodUtil.getQuarterId = function (date, shiftMonth) {
        if (shiftMonth === void 0) { shiftMonth = 0; }
        return PeriodUtil.getQuarterIdByShiftMonth(date, shiftMonth);
    };
    /**
     *  Method return Quarter ID for date. For e.g. quarterId of 2016/01/14 date is 20161
     * @param date
     * @param shiftMonth for FY
     * @returns {number}
     */
    PeriodUtil.getQuarterIdByShiftMonth = function (date, shiftMonth) {
        if (shiftMonth > 11 || shiftMonth < -11)
            throw new Error("Cant call getYearQuarter method with deltaMonth=" + shiftMonth);
        var year = date.getFullYear();
        //month
        var month = date.getMonth() + shiftMonth;
        if (month > 11) {
            year += 1;
            month -= 11;
        }
        if (month < 0) {
            year -= 1;
            month += 11;
        }
        return year * 10 + PeriodUtil.getQuarterIdByMonth(month);
    };
    PeriodUtil.getQuarterIdByMonth = function (month) {
        if (month < 3)
            return 1;
        if (month < 6)
            return 2;
        if (month < 9)
            return 3;
        return 4; //if(9 <= month && month <= 11)
    };
    /**
     *    Method return monthId by Date:
     * For e.g for 2016/7/1 date method return 2016301
     * @param {Date} date
     * @param shiftMonth
     * @returns {number} month id
     */
    PeriodUtil.getMonthId = function (date, shiftMonth) {
        if (shiftMonth === void 0) { shiftMonth = 0; }
        //month
        date.setMonth(date.getMonth() + shiftMonth);
        return PeriodUtil.getQuarterId(date) * 100 + date.getMonth() + 1;
    };
    PeriodUtil.getDayId = function (date) {
        return PeriodUtil.getMonthId(date) * 1000 + date.getDay();
    };
    /**
     * Method return quarterIds for range.
     * For e.g. 2016/05/01 - 2019/1/5 range method return [2016, 2017, 2018, 2019]
     * @param startDate
     * @param endDate
     * @returns {number[]}
     */
    PeriodUtil.getYearIds = function (startDate, endDate, shiftMonth) {
        if (shiftMonth === void 0) { shiftMonth = 0; }
        PeriodUtil.check(startDate, endDate);
        var years = new Array();
        for (var i = startDate.getFullYear(); i <= endDate.getFullYear(); i++) {
            years.push(i);
        }
        return years;
    };
    /**
     * Method return quarterIds for range.
     * For e.g. 2016/05/01 - 2017/1/5 range method return [20162, 20163, 20164, 20171]
     *
     * @param startDate
     * @param endDate
     * @param shiftMonth
     * @returns {Array<number>}
     */
    PeriodUtil.getQuarterIds = function (startDate, endDate, shiftMonth) {
        if (shiftMonth === void 0) { shiftMonth = 0; }
        PeriodUtil.check(startDate, endDate);
        var startYearQuarter = PeriodUtil.getQuarterId(startDate, shiftMonth), endYearQuarter = PeriodUtil.getQuarterId(endDate, shiftMonth);
        var list = new Array();
        for (var i = startYearQuarter; i <= endYearQuarter; i = PeriodUtil.quarterAdd(i)) {
            list.push(i);
        }
        return list;
    };
    /**
     * Method return monthIds for range.
     * For e.g. 2016/05/01 - 2016/7/5 range method return [20162, 20163, 20164, 20171]
     *
     * @param startDate
     * @param endDate
     * @returns {Array<number>}
     */
    PeriodUtil.getMonthIds = function (startDate, endDate, shiftMonth) {
        if (shiftMonth === void 0) { shiftMonth = 0; }
        PeriodUtil.check(startDate, endDate);
        var startYearMonth = PeriodUtil.getMonthId(startDate, shiftMonth), endYearMonth = PeriodUtil.getMonthId(endDate, shiftMonth);
        var list = new Array();
        for (var i = startYearMonth; i <= endYearMonth; i = PeriodUtil.monthAdd(i)) {
            list.push(i);
        }
        return list;
    };
    PeriodUtil.getDayIds = function (startDate, endDate) {
        PeriodUtil.check(startDate, endDate);
        var list = [];
        var i = new Date(startDate);
        while (i.getTime() <= endDate.getTime()) {
            list.push(new Date(i));
            i.setDate(i.getDate() + 1);
        }
        return list;
    };
    PeriodUtil.getSemiAnnualId = function (date, shiftMonth) {
        if (shiftMonth === void 0) { shiftMonth = 0; }
        return PeriodUtil.getSemiAnnualIdByShiftMonth(date, shiftMonth);
    };
    PeriodUtil.getSemiAnnualIdByShiftMonth = function (date, shiftMonth) {
        if (shiftMonth > 11 || shiftMonth < -11)
            throw new Error("Cant call getYearQuarter method with deltaMonth=" + shiftMonth);
        var year = date.getFullYear();
        //month
        var month = date.getMonth() + shiftMonth;
        if (month > 11) {
            year += 1;
            month -= 11;
        }
        if (month < 0) {
            year -= 1;
            month += 11;
        }
        var semiAnnualId = year * 100;
        return semiAnnualId + (month > 5 ? 2 : 1);
    };
    PeriodUtil.getSemiAnnualIds = function (startDate, endDate, shiftMonth) {
        if (shiftMonth === void 0) { shiftMonth = 0; }
        PeriodUtil.check(startDate, endDate);
        var startYearSemiAnnual = PeriodUtil.getSemiAnnualId(startDate, shiftMonth), endYearSemiAnnual = PeriodUtil.getSemiAnnualId(endDate, shiftMonth);
        var list = new Array();
        for (var i = startYearSemiAnnual; i <= endYearSemiAnnual; i = PeriodUtil.semiAnnualAdd(i)) {
            list.push(i);
        }
        return list;
    };
    PeriodUtil.semiAnnualAdd = function (semiAnnualId) {
        var semiAnnual = semiAnnualId % 100;
        var year = Math.floor(semiAnnualId / 100);
        if (2 < semiAnnual || semiAnnual < 0) {
            throw new Error("Invalid quarterId " + semiAnnualId);
        }
        if (semiAnnual === 2)
            return (year + 1) * 100 + 1;
        return semiAnnualId + 1;
    };
    return PeriodUtil;
}());
exports.PeriodUtil = PeriodUtil;
//# sourceMappingURL=period.util.js.map